<template>
  <v-card
    height="100%"
  >
    <v-card-title>{{ $t('profile.affProfile') }}</v-card-title>
    <v-skeleton-loader
      v-if="$apollo.loading"
      type="card"
      :tile="true"
      class="mx-auto"
      width="100%"
    />
    <v-form
      v-if="!$apollo.loading && me"
    >
      <v-flex mb-7>
        <v-text-field
          v-if="me.obfuscated_phone"
          id="phone"
          v-model.trim="me.obfuscated_phone"
          name="phone"
          :label="$t('profile.phone')"
          disabled
        />
        <v-text-field
          id="telegram"
          v-model.trim="me.telegram"
          name="telegram"
          prefix="@"
          :label="$t('profile.telegram')"
          :placeholder="$t('profile.telegramPlaceholder')"
        >
          <template v-slot:append>
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <v-icon v-on="on">
                  mdi-information-outline
                </v-icon>
              </template>
              {{ $t('profile.telegramTooltip') }}
            </v-tooltip>
          </template>
        </v-text-field>
        <v-text-field
          id="messenger"
          v-model.trim="messenger"
          name="messenger"
          prefix="@"
          :label="$t('profile.messenger')"
          :placeholder="$t('profile.messengerPlaceholder')"
        >
          <template v-slot:append>
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <v-icon v-on="on">
                  mdi-information-outline
                </v-icon>
              </template>
              {{ $t('profile.messengerTooltip') }}
            </v-tooltip>
          </template>
        </v-text-field>
        <v-text-field
          id="telegram_group"
          v-model.trim="telegram_group"
          name="telegram_group"
          prefix="@"
          :label="$t('profile.telegramGroup')"
          :placeholder="$t('profile.telegramGroupPlaceholder')"
        >
          <template v-slot:append>
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <v-icon v-on="on">
                  mdi-information-outline
                </v-icon>
              </template>
              {{ $t('profile.telegramGroupTooltip') }}
            </v-tooltip>
          </template>
        </v-text-field>
        <v-checkbox
          v-model="me.allow_to_publish"
          color="primary"
        >
          <template
            v-slot:label
          >
            <small>{{ $t('profile.allowToPublish') }}</small>
          </template>
        </v-checkbox>
      </v-flex>
    </v-form>
    <v-card-actions>
      <v-spacer />
      <v-btn
        text
        outlined
        :disabled="loading"
        :loading="loading"
        @click.prevent="save"
      >
        {{ $t('profile.saveButton') }}
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import UPDATE_USER_MUTATION from "@/graphql/mutations/UpdateUser.gql";

export default {
  name: "AffProfile",
  data() {
    return {
      loading: false,
      showCode: false,
      dialog: false
    };
  },
  validations() {
    return {
      me: this.rules
    };
  },
  computed: {
    messenger: {
      set(val) {
        this.me.messenger = val
          .replace("https://www.facebook.com/", "")
          .replace("?ref=bookmarks", "");
      },
      get() {
        return this.me.messenger;
      }
    },
    telegram_group: {
      set(val) {
        this.me.telegram_group = val.replace("https://t.me/", "");
      },
      get() {
        return this.me.telegram_group;
      }
    }
  },
  methods: {
    save() {
      this.loading = true;
      let form = {};

      if (this.messenger != "" && this.messenger != null)
        form.messenger = this.messenger;

      if (this.telegram_group != "" && this.telegram_group != null)
        form.telegram_group = this.me.telegram_group;

      if (this.me.telegram != "" && this.me.telegram != null)
        form.telegram = this.me.telegram;

      form.allow_to_publish = this.me.allow_to_publish;

      this.$apollo
        .mutate({
          mutation: UPDATE_USER_MUTATION,
          variables: form
        })
        .then(data => {
          this.loading = false;
          this.responseHandler(this.$t("globals.updatedSuccess"));
        })
        .catch(error => {
          this.errorHandler(error);
          this.loading = false;
        });
    }
  },
  apollo: {
    me: {
      query: require("@/graphql/queries/Me.gql")
    }
  }
};
</script>

<style lang="scss" >
@import "@/styles/material-dashboard/_colors.scss";
.profile {
  .v-card__title {
    margin-bottom: 15px;
  }
  .v-card__text {
    padding: 3px;
    span {
      font-weight: 400;
      font-size: 20px;
      margin: 10px;
      color: $black;
    }
  }
}
</style>
